export default {
  feature: 'פיצ׳ר',
  features: 'פיצ׳רים',
  featuresOf: 'פיצ׳רים של {{type}}',
  'feature.list.title': 'ניהול פיצ׳רים',
  'feature.list.subtitle': 'נהל את פיצ׳רי האפליקציה ביעילות.',
  'feature.list.search.placeholder': 'חפש פיצ׳רים לפי שם או תיאור',
  'feature.info': 'פרטי הפיצ׳ר',
  'feature.form.title': 'כותרת הפיצ׳ר',
  'feature.form.description': 'תיאור הפיצ׳ר',
  'feature.form.assignments': 'הקצאות',
  'feature.form.slug': 'סלאג',
  'feature.form.slug.helper':
    'מזהה יציב שאפליקציות צרכניות מתייחסות אליו בקוד. אותיות קטנות, ספרות, קו תחתון (עד 50 תווים). לא ניתן לשינוי כאשר הפיצ׳ר פעיל.',
  'feature.form.slug.invalid':
    'הסלאג חייב להתחיל באות לטינית קטנה ולהכיל רק אותיות לטיניות קטנות, ספרות וקווים תחתונים (עד 50 תווים).',
  'feature.info.helper':
    'ספק כותרת ברורה, תיאור תמציתי וסוג מתאים להגדרת הפיצ׳ר',
  'feature.msg.deactivateBlocked': 'השבתה חסומה',
  'feature.msg.deactivateBlockedDescription':
    'לא ניתן להשבית פיצ׳ר זה כיוון שהוא כבר נמצא בשימוש עבור {{subscriptionName}}.',
  'feature.actions.navigateToSubscription': 'עבור למנוי',
  'feature.utilityInfo': 'מידע על שימוש בפיצ׳ר (Utility)',
  'feature.utility.cardTitle': 'מידע על מונה שימוש',
  'feature.utility.helper': 'הגדר מגבלות שימוש ותקופות צריכה עבור פיצ׳ר זה',
  'feature.utility.enabled': 'להפעיל מגבלות שימוש?',
  'feature.utility.counter': 'מונה שימוש',
  'feature.utility.duration': 'משך שימוש',
  'feature.usage': 'Usage',
  'feature.save.confirm.title': 'אפשרויות שמירה',
  'feature.save.confirm.description': 'שמור כחדש או עדכן קיים',
  'feature.assigned.subscriptions': 'מנויים משויכים ({{count}})',
  'feature.subscriptions.helper':
    'כדי לשייך מנויים, באפשרותך לבחור מתוך רשימת המנויים הפעילים הזמינה.',
  'feature.msg.unAssignConfirm': 'האם אתה בטוח שברצונך לבטל את שיוך המנוי הזה?',
};
